import React, { useEffect, useMemo, useState } from "react";
import variableLanguage from "../../../utils/hooks/hookGetVariablesLanguage";
import CardProgressStudents from "./CardProgressStudents";
import "./ProgressStudents.scss";
import UseWindowSize from "../../../utils/hooks/hookResize";
import TitleProgressColumnsStudents from "./TitleProgressColumnsStudents";
const ProgressStudents = (props) => {
  const { allProgress, isLightTheme = false } = props;

  const variable_19 = variableLanguage({
    keyPage: "groupsList",
    keyVariable: "variable_19",
  });
  const allUsers = allProgress?.length;

  const notProgress = useMemo(() => {
    if (allUsers === 0) return [];
    return allProgress
      .map((user) => {
        if (user.progress === 0) return user;
      })
      .filter((user) => user !== undefined);
  }, [allProgress]);
  console.log("notProgress", notProgress);
  const startProgress = useMemo(() => {
    if (allUsers === 0) return [];
    return allProgress
      .map((user) => {
        if (user.progress > 0 && user.progress < 100) return user;
      })
      .filter((user) => user !== undefined);
  }, [allProgress]);
  const finishProgress = useMemo(() => {
    if (allUsers === 0) return [];
    return allProgress
      .map((user) => {
        if (user.progress === 100) return user;
      })
      .filter((user) => user !== undefined);
  }, [allProgress]);

  return (
    <div className="progress_study_block">
      {allProgress && allProgress.length > 0 ? (
        <>
          <div className="not_progress">
            <TitleProgressColumnsStudents
              title="Не начали"
              countUser={notProgress.length}
              allUsers={allUsers}
              isLightTheme={isLightTheme}
            />
            {notProgress.map((elem, indx) => (
              <CardProgressStudents
                elem={elem}
                indx={indx}
                isLightTheme={isLightTheme}
              />
            ))}
          </div>
          <div className="start_progress">
            <TitleProgressColumnsStudents
              title="В процессе"
              countUser={startProgress.length}
              allUsers={allUsers}
              isLightTheme={isLightTheme}
            />

            {startProgress.map((elem, indx) => (
              <CardProgressStudents
                elem={elem}
                indx={indx}
                isLightTheme={isLightTheme}
              />
            ))}
          </div>
          <div className="finish_progress">
            <TitleProgressColumnsStudents
              title="Завершили"
              countUser={finishProgress.length}
              allUsers={allUsers}
              isLightTheme={isLightTheme}
            />
            {finishProgress.map((elem, indx) => (
              <CardProgressStudents
                elem={elem}
                indx={indx}
                isLightTheme={isLightTheme}
              />
            ))}
          </div>
        </>
      ) : (
        <div className={"no_content"}> {variable_19}</div>
      )}
    </div>
  );
};

export default ProgressStudents;
